import React from 'react'
import PropTypes from 'prop-types'

import UseAccount from '@connects/account'
import UseAuth from '@connects/auth'
import UseCounts from '@connects/counts'
import combine from '@connects/combine'

// TODO: use connects for auth and account instead of hard wiring
const appContainer = (App) => {

	// @UseAccount()
	// @UseAuth()
	@combine({
		auth: UseAuth(),
		account: UseAccount(),
		counts: UseCounts(),
	})
  class AppContainer extends React.Component {

  	static propTypes = {
  		location: PropTypes.object.isRequired,
  	}

    componentDidMount() {
    	const { account, counts } = this.props;
	    account.actions.get();
	    counts.actions.get();
	  }

	  componentDidUpdate(prevProps) {
	  	if(this.props.location.pathname !== prevProps.location.pathname) {
	  		console.log(this.props.location);
	  		this.onRouteChanged();
	  	}
	  }

	  onRouteChanged() {
	  	this.props.counts.actions.get();
	  }

    render() {
      return (<App {...this.props} />)
    }

  }

  return AppContainer;

}

export default appContainer;


// WEBPACK FOOTER //
// ./src/scenes/App/AppContainer.jsx